import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { CardsComponent } from "@components/cards/cards.component";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { ArbetsorderAtgardProduktionAvslutadGrotComponent } from "./grot/arbetsorder-atgard-produktion-avslutad-grot.component";
import { ArbetsorderAtgardProduktionAvslutadLevComponent } from "./lev/arbetsorder-atgard-produktion-avslutad-lev.component";
import { ArbetsorderAtgardProduktionAvslutadRvComponent } from "./rv/arbetsorder-atgard-produktion-avslutad-rv.component";

@Component({
    selector: "rask-arbetsorder-atgard-produktion-avslutad",
    templateUrl: "./arbetsorder-atgard-produktion-avslutad.component.html",
    styleUrls: ["./arbetsorder-atgard-produktion-avslutad.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardsComponent,
        ArbetsorderAtgardProduktionAvslutadRvComponent,
        ArbetsorderAtgardProduktionAvslutadGrotComponent,
        ArbetsorderAtgardProduktionAvslutadLevComponent
    ]
})
export class ArbetsorderAtgardProduktionAvslutadComponent {
    @Input() arbetsorder: IArbetsorderDetail;
    @Input() rootForm: UntypedFormGroup;

    get hasAtgarder(): boolean {
        return this.arbetsorder?.atgarder.length > 0;
    }

    get isGrot(): boolean {
        return this.arbetsorder.isGrotskotning;
    }

    get isLeveransvirke(): boolean {
        return this.arbetsorder.isLeveransvirke;
    }

    sortBy(prop: string) {
        return this.arbetsorder.atgarder.sort((a, b) => {
            if (a[prop] > b[prop]) {
                return 1;
            }
            return  a[prop] === b[prop] ? 0 : -1;
        });
    }
}
